<template>
  <div :class="$route.name + '-page'">
    <Header ref="pchd" v-if="(!isPage('bzsm'))&&(!isPage('lxwm'))" />
    <div class="content_template">
      <router-view v-if="RouterShow"/>
    </div>
    <Footer v-if="(!isPage('bzsm'))&&(!isPage('lxwm'))" />
  </div>
</template>
<script>
import { myMixin } from "@/mixins/tool.js";
import Header from "./myHeader";
import Footer from "./myFooter";

export default {
  name: "pc",
  components: {
    Header,
    Footer,
  },
  mixins: [myMixin]
};
</script>
<style lang="less">
@import "~@/assets/todoCenter/default/css/taskcenter-new.less";
@import "~@/assets/todoCenter/default/css/other.less";
</style>
<style>
.content_template {
  width: 100%;
  margin: 0px auto;
  min-height: 800px;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/index.vue